export enum BlockLayout {
  AUTO = 'auto',
  WIDE = 'wide',
  IMAGE_LEFT = 'img-left',
  IMAGE_RIGHT = 'img-right',
}
